import { FC } from 'react';
import { SocialLink } from '#advertDetail/components/social-link/SocialLink';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import socialLinkListCss from '../../assets/social-link/social-link-list.module.scss';
import { SocialLinkAlias } from '#components/social-link';

const SocialLinkList: FC = () => {
  const {
    advert: {
      contactData,
    },
  } = useAdvertDetailContext();

  if (contactData.isEmpty || !contactData.socialLinkList) {
    return null;
  }

  const socialLinkListFiltered = contactData.socialLinkList
    .filter((socialLink) => socialLink.alias !== SocialLinkAlias.whatsApp)
    .filter((socialLink) => socialLink.alias !== SocialLinkAlias.telegram);

  if (socialLinkListFiltered.length === 0) {
    return null;
  }

  const socialLinkList = socialLinkListFiltered.map((socialLink) => (
    <SocialLink key={socialLink.alias} socialLink={socialLink} />
  ));

  return (
    <div className={socialLinkListCss.socialLinkList}>
      {socialLinkList}
    </div>
  );
};

export { SocialLinkList };
